import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useRoutes } from "react-router-dom";
import Switch from "react-switch";
import GuardIcon from "../../assets/svg/GuardIcon.svg";
import LockIcon from "../../assets/svg/LockIcon.svg";
import RightArrow from "../../assets/svg/RightArrow";
import Header from "../../components/Header/Header";
import ScrollToTop from "../../components/Hooks/ScrollToTop";
import axios from "../../components/Hooks/axios";
import { setUserObject } from "../../redux/slices/authSlice";
import Comment from "./Comment";
import { FameoX } from "./FameoX";
import { LivePrivacy } from "./Live";
import { Mention } from "./Mention";
import { Message } from "./Message";
import Post from "./Post";
import styles from "./Privacy.module.scss";
import { toast } from "react-toastify";
import { setTempEmail } from "../../redux/slices/tempSlice";
import { FaAngleLeft } from "react-icons/fa6";
import logo from "../../assets/icons/Fameo-X-App-icon.png";
import { IoIosArrowBack } from "react-icons/io";

const Privacy = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { user } = useSelector((state) => state.auth);
	const [Account, setAccount] = useState(false);
	const [Posts, setPosts] = useState(false);
	const [Mentions, setMentions] = useState(false);
	const [Story, setStory] = useState(false);
	const [Live, setLive] = useState(false);
	const [Messages, setMessages] = useState(false);
	const [SubPage, setSubPage] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
	const [Comments, setComments] = useState(!isMobile);
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1024);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		if (user === null) return;
		setAccount(user?.is_private === "Yes" && true);
	}, [user]);

	const handelClicks = (action) => {
		if (action === "Comment") {
			setComments(!Comments);
			setPosts(false);
			setMentions(false);
			setStory(false);
			setLive(false);
			setMessages(false);
		} else if (action === "Posts") {
			setPosts(!Posts);
			setComments(false);
			setMentions(false);
			setStory(false);
			setLive(false);
			setMessages(false);
		} else if (action === "Mentions") {
			setMentions(!Mentions);
			setPosts(false);
			setComments(false);
			setStory(false);
			setLive(false);
			setMessages(false);
		} else if (action === "Story") {
			setStory(!Story);
			setPosts(false);
			setComments(false);
			setMentions(false);
			setLive(false);
			setMessages(false);
		} else if (action === "Live") {
			setLive(!Live);
			setPosts(false);
			setComments(false);
			setMentions(false);
			setStory(false);
			setMessages(false);
		} else if (action === "Messages") {
			setMessages(!Messages);
			setPosts(false);
			setComments(false);
			setMentions(false);
			setStory(false);
			setLive(false);
		} else {
			setComments(false);
			setPosts(false);
			setMentions(false);
			setStory(false);
			setLive(false);
			setMessages(false);
		}

		if (isMobile) {
			setSubPage(true);
		}
	};

	const handelPrivateSwitch = (e) => {
		axios
			.get(`/auth/make-account-private?status=${e ? "Yes" : "No"}`)
			.then(({ data }) => {
				console.log(data.data);
				setAccount(e);
				dispatch(setUserObject(data.data));
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const handelChangePassword = () => {
		axios
			.post("/auth/otp", {
				email: user?.email,
			})
			.then(({ data }) => {
				toast.success(data?.message);
				toast.info(data.otp, {
					autoClose: 10000,
				});
				dispatch(setTempEmail(user?.email));
				navigate("/verification-code", { state: { pageLocation: "/Privacy", userId: user?._id } });
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const handleMobileNavigation = () => {
		if (Comments) {
			setComments(false);
			setSubPage(false);
		}
		if (Posts) {
			setPosts(false);
			setSubPage(false);
		}
		if (Story) {
			setStory(false);
			setSubPage(false);
		}
		if (Mentions) {
			setMentions(false);
			setSubPage(false);
		}
		if (Account) {
			setAccount(false);
			setSubPage(false);
		}
		if (Live) {
			setLive(false);
			setSubPage(false);
		}
		if (Messages) {
			setMessages(false);
			setSubPage(false);
		}
		if (!SubPage) {
			navigate("/Setting");
		}
	};

	return (
		<div className="App">
			<div className="MainContainer">
				<ScrollToTop />
				{!isMobile && <Header />}

				{isMobile && (
					<div className={styles.HeaderComponent}>
						<div className={styles.logoContainer}>
							<Link to="/home">
								<img src={logo} alt="logo" />
							</Link>
						</div>
						<div className={styles.HeaderBackButton}>
							<button onClick={handleMobileNavigation}>
								{" "}
								<IoIosArrowBack />
							</button>
						</div>
					</div>
				)}

				{!isMobile && (
					<div className={`${styles.Container} ${styles.Privacy}`}>
						<div className={styles.BackButton}>
							<button
								onClick={() => {
									navigate(-1);
								}}>
								<FaAngleLeft />
							</button>
						</div>

						<div className={styles.PrivacyCont}>
							<div className={styles.LeftPrivacyContainer}>
								<div className={styles.TopLeftContainer}>
									<h1 className={styles.PrivacyText}>Privacy</h1>
								</div>
								<div className={styles.PrivateAccountBox}>
									<div>
										<img src={LockIcon} alt="" />
										<div>
											<h3>Private Account</h3>
											<p>only people who follow can see ur post and message you </p>
										</div>
									</div>

									<Switch
										onChange={handelPrivateSwitch}
										checked={Account}
										offColor={"#c4c4c4"}
										onColor={"#EFEFEF"}
										// offHandleColor={""}
										onHandleColor={"#A6539D"}
										uncheckedIcon={false}
										checkedIcon={false}
										activeBoxShadow={"0 0 0px 0px #909AFF"}
										height={30}
										width={64}
									/>
								</div>
								<div className={styles.PrivateAccountBox}>
									<div className={styles.changePassword}>
										<img src={GuardIcon} alt="" />
										<div>
											<h3>Change Password</h3>
											<p>Change your password form here</p>
										</div>
									</div>
									<button type="button" style={{ paddingLeft: "4rem" }} onClick={handelChangePassword}>
										<RightArrow />
									</button>
								</div>
								<h5 className={styles.InteractionsText}>Interactions</h5>
								<div className={styles.InteractionsContainer}>
									<div
										className={`${styles.InteractionsBox} ${Comments && styles.active}`}
										onClick={() => handelClicks("Comment")}>
										<div>
											<h3>Comments</h3>
											<p>Manage your comment's</p>
										</div>
										<RightArrow />
									</div>
									<div
										className={`${styles.InteractionsBox} ${Posts && styles.active}`}
										onClick={() => handelClicks("Posts")}>
										<div>
											<h3>Posts</h3>
											<p>Manage your posts</p>
										</div>
										<RightArrow />
									</div>
									<div
										className={`${styles.InteractionsBox} ${Mentions && styles.active}`}
										onClick={() => toast.info("Coming Soon...")}>
										<div>
											<h3>Mentions</h3>
											<p>Manage your mentions</p>
										</div>
										<RightArrow />
									</div>
									<div
										className={`${styles.InteractionsBox} ${Story && styles.active}`}
										onClick={() => handelClicks("Story")}>
										<div>
											<h3>Story</h3>
											<p>Manage your story</p>
										</div>
										<RightArrow />
									</div>

									<div
										className={`${styles.InteractionsBox} ${Live && styles.active}`}
										onClick={() => toast.info("Coming Soon...")}>
										<div>
											<h3>Live</h3>
											<p>Manage your Live</p>
										</div>
										<RightArrow />
									</div>

									<div
										className={`${styles.InteractionsBox} ${Messages && styles.active}`}
										onClick={() => toast.info("Coming Soon...")}>
										<div>
											<h3>Messages</h3>
											<p>Manage your Messages</p>
										</div>
										<RightArrow />
									</div>
								</div>
							</div>
							<div className={styles.RightPrivacyContainer}>
								<div className={styles.AllComponentRenders}>
									{Comments && <Comment isMobile={isMobile} />}
									{Posts && <Post isMobile={isMobile} />}
									{Mentions && <Mention isMobile={isMobile} />}
									{Story && <FameoX isMobile={isMobile} />}
									{Live && <LivePrivacy isMobile={isMobile} />}
									{Messages && <Message isMobile={isMobile} />}
								</div>
							</div>
						</div>
					</div>
				)}
				{isMobile && (
					<div className={`${styles.Container} ${styles.Privacy}`}>
						<div className={styles.PrivacyCont}>
							<div className={styles.LeftPrivacyContainer}>
								<div className={styles.TopLeftContainer}>
									<h1 className={styles.PrivacyText}>
										{Live
											? "Live Setting"
											: Story
												? "Story Setting"
												: Posts
													? "Posts Setting"
													: Comments
														? "Comment Setting"
														: Mentions
															? "Mentions Setting"
															: Messages
																? "Messages Setting"
																: "Privacy"}
									</h1>
								</div>
								{!SubPage && (
									<>
										<div className={styles.PrivateAccountBox}>
											<div style={{ display: "flex", gap: "4rem", alignItems: "center" }}>
												<img src={LockIcon} alt="" />
												<div>
													<h3>Private Account</h3>
													<p>only people who follow can see ur post and message you </p>
												</div>
											</div>

											<Switch
												onChange={handelPrivateSwitch}
												checked={Account}
												offColor={"#c4c4c4"}
												onColor={"#EFEFEF"}
												// offHandleColor={""}
												onHandleColor={"#A6539D"}
												uncheckedIcon={false}
												checkedIcon={false}
												activeBoxShadow={"0 0 0px 0px #909AFF"}
												height={35}
												width={70}
											/>
										</div>
										<div className={styles.PrivateAccountBox}>
											<div className={styles.changePassword}>
												<img src={GuardIcon} alt="" />
												<div>
													<h3>Change Password</h3>
													<p>Change your password form here</p>
												</div>
											</div>
											<button type="button" style={{ paddingLeft: "4rem" }} onClick={handelChangePassword}>
												<RightArrow />
											</button>
										</div>
										<h5 className={styles.InteractionsText}>Interactions</h5>
										<div className={styles.InteractionsContainer}>
											<div
												className={`${styles.InteractionsBox} ${Comments && styles.active}`}
												onClick={() => handelClicks("Comment")}>
												<div>
													<h3>Comments</h3>
													<p>Manage your comment's</p>
												</div>
												<RightArrow />
											</div>
											<div
												className={`${styles.InteractionsBox} ${Posts && styles.active}`}
												onClick={() => handelClicks("Posts")}>
												<div>
													<h3>Posts</h3>
													<p>Manage your posts</p>
												</div>
												<RightArrow />
											</div>
											<div
												className={`${styles.InteractionsBox} ${Mentions && styles.active}`}
												onClick={() => toast.info("Coming Soon...")}>
												<div>
													<h3>Mentions</h3>
													<p>Manage your mentions</p>
												</div>
												<RightArrow />
											</div>
											<div
												className={`${styles.InteractionsBox} ${Story && styles.active}`}
												onClick={() => handelClicks("Story")}>
												<div>
													<h3>Story</h3>
													<p>Manage your story</p>
												</div>
												<RightArrow />
											</div>

											<div
												className={`${styles.InteractionsBox} ${Live && styles.active}`}
												onClick={() => toast.info("Coming Soon...")}>
												<div>
													<h3>Live</h3>
													<p>Manage your Live</p>
												</div>
												<RightArrow />
											</div>

											<div
												className={`${styles.InteractionsBox} ${Messages && styles.active}`}
												onClick={() => toast.info("Coming Soon...")}>
												<div>
													<h3>Messages</h3>
													<p>Manage your Messages</p>
												</div>
												<RightArrow />
											</div>
										</div>
									</>
								)}
							</div>
							{SubPage && (
								<div className={styles.RightPrivacyContainer}>
									<div className={styles.AllComponentRenders}>
										{Comments && <Comment isMobile={isMobile} />}
										{Posts && <Post isMobile={isMobile} />}
										{Mentions && <Mention isMobile={isMobile} />}
										{Story && <FameoX isMobile={isMobile} />}
										{Live && <LivePrivacy isMobile={isMobile} />}
										{Messages && <Message isMobile={isMobile} />}
									</div>
								</div>
							)}
						</div>
					</div>
				)}
				{/* <div className={styles.LeftExpandableContainer}>
									<div className={styles.AllComponentRenders}>
										{Comments && <Comment />}
									</div>
								</div> */}
				{/* <div className={styles.LeftExpandableContainer}>
									<div className={styles.AllComponentRenders}>
										{Posts && <Post />}
									</div>
								</div> */}
				{/* <div className={styles.LeftExpandableContainer}>
									<div className={styles.AllComponentRenders}>
										{Mentions && <Mention />}									</div>


								</div> */}
				{/* <div className={styles.LeftExpandableContainer}>
									<div className={styles.AllComponentRenders}>
										{Story && <FameoX />}
									</div>

								</div> */}
				{/* <div className={styles.LeftExpandableContainer}>
									<div className={styles.AllComponentRenders}>
										{Live && <LivePrivacy />}

									</div>
								</div> */}
				{/* <div className={styles.LeftExpandableContainer}>
									<div className={styles.AllComponentRenders}>
										{Messages && <Message />}
									</div>
								</div> */}
			</div>
		</div>
	);
};

export default Privacy;

